import { useContext, useEffect, useState } from "react";
import Container from "../../components/Container/Container";
import Body from "../../components/Body/Body";
import "./News.css";
import NewsData from './NewsData.json'
import { Link } from "react-router-dom";
import listApi from "../../services/api";
import { AuthContext } from "../../context/AuthContext";
  const noImg = 'https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg'
  const url_img = 'https://matmasocaivan.com/MMS_data/'

export const News = () => {
  const { userData } = useContext(AuthContext);
  const [news, setNews] = useState([]);

  const latestNews = news.filter((post) => !post.featured);

  let featuredPost = news.find((post) => post.featured) || latestNews[0] || null;

  console.log(featuredPost)

  const createSlug = (title) => {
    return title.toLowerCase()
        .replace(/[^a-z0-9]+/g, '-') // Thay ký tự đặc biệt bằng dấu -
        .replace(/^-+|-+$/g, ''); // Loại bỏ dấu - ở đầu & cuối
};

const fetchListNews = async () => {
  try {
    const response = await fetch(listApi.listNews, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        session_id: userData.session_id
      })
    });
    const data = await response.json();
    console.log("Check data news----->", data)
    if (data.code === 200) {
      setNews(data.list_news);
    }
  } catch (error) {
    console.error("Lỗi khi lấy dữ liệu sản phẩm:", error);
  }
};

useEffect(() => {
  fetchListNews()
}, [])


  return (
    <Container>
    <Body>
      <h2 className="news-title">Tin tức</h2>

      <div className="news-container">
        {/* Bài viết nổi bật chính */}
        {featuredPost && (
          <Link to={`/News/${createSlug(featuredPost.title)}`} className="main-featured">
            <img src={ featuredPost.url_picture == "picture/" || featuredPost.url_picture == "" ? noImg : url_img +featuredPost.url_picture }  alt={featuredPost.title} className="featured-image" />
            <div className="featured-info">
              <h2>{featuredPost.title}</h2>
              <p>{featuredPost.news_info}</p>
            </div>
          </Link>
        )}

        {/* Sidebar danh sách bài viết nổi bật */}
        <div className="sidebar">
          <h3>Bài viết nổi bật</h3>
          <ul>
            {latestNews.slice(0, 6).map((post) => (
               <Link to={`/News/${createSlug(post.title)}`} key={post.id} className="news-card sidebar-item">
                 <img src={ post.url_picture == "picture/" || post.url_picture == "" ? noImg : url_img +post.url_picture } />
                <span>{post.title}</span>
              </Link>
            ))}
          </ul>
        </div>
      </div>

      {/* Danh sách bài viết mới nhất */}
      <h3 className="latest-title">Bài viết mới nhất</h3>
      <div className="latest-news">
        {latestNews.map((post) => (
      <Link to={`/News/${createSlug(post.title)}`} key={post.id} className="news-card news-item">
            <img src={ post.url_picture == "picture/" || post.url_picture == "" ? noImg : url_img +post.url_picture } />
            <h4>{post.title}</h4>
            <small>{post.publishedAt}</small>
            <p>{post.news_info}</p>
          </Link>
        ))}
      </div>
    </Body>
  </Container>
  );
};

export default News;
